import React from 'react';

import SEO from '@/components/seo';
import Layout from '@/components/layout';
import homeData from '../data/v2/home';
import { PageLayout } from '@/components/v2/global';
import { HeroSection } from '@/components/v2/home/HeroSection';
import { HighlightsSection } from '@/components/v2/home/HighlightsSection';
import { FeaturesSection } from '@/components/v2/home/FeaturesSection';
import { TestimonialsSection } from '@/components/v2/home/TestimonialsSection';
import { ModelSupportSection } from '@/components/v2/home/ModelSupportSection';
import { DemoSection } from '@/components/v2/home/DemoSection';
import { CTASection } from '@/components/v2/home/CTASection';
import { NewFooter } from '@/components/v2/global/NewFooter';
import { BigAnnouncement } from '@/components/v2/home/BigAnnouncement';

const Index = () => {
  const {
    seo,
    hero,
    bigAnnouncement,
    highlights,
    testimonials,
    features,
    modelSupport,
    slmFeatures,
    cta,
  } = homeData;
  return (
    <Layout hasFooter={false}>
      <SEO title={seo.title} description={seo.description} />
      <PageLayout>
        <HeroSection {...hero} />
        <BigAnnouncement {...bigAnnouncement} />
        <HighlightsSection {...highlights} />
        <TestimonialsSection {...testimonials} />
        <FeaturesSection {...features} />
        <ModelSupportSection {...modelSupport} />
        <DemoSection {...slmFeatures} />
        <CTASection {...cta} />
        <NewFooter />
      </PageLayout>
    </Layout>
  );
};

export default Index;
